// extracted by mini-css-extract-plugin
module.exports = {"base":"AnchoredCardImage_base__QK17Z","cardImg":"AnchoredCardImage_cardImg___RCrp","croppedCardImg":"AnchoredCardImage_croppedCardImg__LVZnu"};